import { isSolarMount, products, isNxtHorizon} from '__common/constants/products';
import { ROOF_PITCH } from '__editor/panelsEditor/components/tiltedRoof/roofPitch';
import { InputUnit } from 'engineering/components/engineeringProjectDocuments/utils/unitTypes';

export function parseDataForOsImport(product: string|number, initData, moduleData: modelData, payload: any) {
  
  const pId = product;

  const data = {
    os_project_id: initData.os_project_id || 'default-os-project-id',
    os_default_product_id: 25, // Default product ID for OpenSolar
    os_racking_type: initData.os_racking_type || 25, // Default racking type
    os_session_token: initData.os_session_token,
    os_tenant_id: initData.os_tenant_id,
    os_user_id: initData.os_user_id,
    product: pId,
    module: Number(moduleData.module) || Number(initData.module) || 185, // Default module ID
    model: Number(moduleData.id) || Number(initData.model) || 1000001, // Default model ID
    custom_title: '',
    building_height: initData.building_height,
    module_watts: initData.os_module_wattage,
    module_length: initData.os_module_length,
    module_width: initData.os_module_width,
    module_thickness: initData.os_module_thickness,
    module_weight: initData.os_module_weight,
    zipcode: initData.zipcode,
    snow_load: initData.snow_load,
    wind_speed: initData.wind_speed || 100, // Default wind speed if not provided
    seismic_ss: Number(Number(initData.seismic_ss || 0.1).toFixed(2)), // Default seismic_ss if not provided
    elevation: initData.elevation,
    wind_exposure: initData.wind_exposure,
    building_code: initData.building_code,
    roof_type: initData.roof_type,
    row_spacing: initData.row_spacing,
    rafter_spacing_inches: initData.rafter_spacing_inches || 24,
    ...payload
  };

  if (isSolarMount(pId)) {
    data.mid_clamps_choices = initData.mid_clamps_choices || 1;
    data.end_clamps_choices = initData.end_clamps_choices || 1;
    data.roof_pitch = ROOF_PITCH[initData.roof_pitch] || 5;
    data.input_unit = InputUnit.CUSTOMARY;
  }

  if (isNxtHorizon(pId)) {
    data.mid_clamps_choices = initData.mid_clamps_choices || 4;
    data.end_clamps_choices = initData.end_clamps_choices || 4;
    data.roof_pitch = ROOF_PITCH[initData.roof_pitch] || 5;
  }

  return data;
}

export function validateDataForImport(data) {
  if (data.wind_speed === undefined) {
    alert('Set wind speed before import');
    return false;
  }

  if (data.snow_load === undefined) {
    alert('Set snow load before import');
    return false;
  }

  if (data.seismic_ss === undefined) {
    alert('Set seismic_ss before import');
    return false;
  }

  if (!data.model || !data.module) {
    return false;
  }

  if (!data.module || !data.model) {
    return false;
  }

  return true;
}
